<template>
    <v-menu
        :close-on-content-click="false"
        v-model="valueData"
        transition="scale-transition"
        offset-y
        :nudge-right="100"
    >
        <template v-slot:activator="{ on }">
          <div @click="showDatepicker">
            <ValidationProvider ref="picker" mode="eager" :rules="validateProviderRulesData" v-slot:default="{ errors }">
                <input-cadu
                  :errorMessage="errors[0]"
                  class="date-picker"
                  :clickIcon="true"
                  :title="title"
                  :placeholder="placeholder"
                  :value="dado"
                  @input="value => organizarDataDado(value)"
                  icon="calendar"
                  v-mask="typeMask"
                  :colorText="$vuetify.theme.themes.light.fontColor1"
                  :disabled="disabled"
                  :colorIcon="$vuetify.theme.themes.light.primary1"
                />
            </ValidationProvider>
          </div>
        </template>
        <v-date-picker
            :class="typeCalendar == 'date' ? 'datePicker' : ''"
            v-model="dateValor"
            :allowed-dates="allowedMonths"
            :type="typeCalendar"
            :show-current="showCurrent"
            :width="width"
            :min="minDateData"
            :max="maxDateData"
            color="#00995d"
            locale="pt-br"
            no-title
            actions
            @change="dateSelected()"
            @click:date="orgarnizarData"
            @click:month="orgarnizarData"
        />
    </v-menu>
</template>

<script>
import { mask } from 'vue-the-mask'
import { ValidationProvider } from 'vee-validate'

export default {
  components: {
    ValidationProvider
  },
  directives: {
    mask
  },
  props: {
    validateProviderRules: {
      type: String,
      required: false,
      default: ''
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    value: {
      type: Boolean,
      required: false,
      default: false
    },
    inputTitle: {
      type: String,
      required: true
    },
    inputValue: {
      type: String,
      required: false,
      default: ''
    },
    propDate: {
      type: String,
      required: false,
      default: ''
    },
    propMonths: {
      type: Array,
      required: false,
      // eslint-disable-next-line
      default: () => { return [] }
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    errorMessage: {
      type: String,
      required: false,
      default: ''
    },
    typeCalendar: {
      type: String,
      required: false,
      default: 'month'
    },
    showCurrent: {
      type: Boolean,
      required: false,
      default: false
    },
    width: {
      type: String,
      required: false,
      default: '230'
    },
    showSelectedDate: {
      type: String,
      required: false
    },
    minDate: {
      type: String,
      required: false,
      default: null
    },
    maxDate: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      valueData: this.value,
      title: this.inputTitle,
      dado: this.inputValue,
      date: this.showSelectedDate ? this.showSelectedDate : '',
      months: this.propMonths,
      type: this.typeCalendar,
      typeMask: '',
      dateValor: '',
      minDateData: '',
      maxDateData: '',
      validateProviderRulesData: this.validateProviderRules
    }
  },
  beforeMount () {
    if (this.inputValue) {
      let dataFormatada = this.formatarData(this.inputValue)
      this.dateValor = dataFormatada
    }

    if (this.minDate) {
      let splitMin = this.minDate.split('/')
      this.minDateData = `${splitMin[2]}-${splitMin[1]}-${splitMin[0]}`
    }
    if (this.maxDate) {
      let splitMax = this.maxDate.split('/')
      this.maxDateData = `${splitMax[2]}-${splitMax[1]}-${splitMax[0]}`
    }
    switch (this.type) {
      case 'date':
        this.typeMask = '##/##/####'
        break
      case 'month':
        this.typeMask = '##/####'
    }
  },
  methods: {
    async validateInput () {
      return new Promise(async (resolve, reject) => {
        try {
          let result = await this.$refs.picker.validate()
          resolve(result.valid)
        } catch (err) {
          reject(err)
        }
      })
    },

    async validate () {
      try {
        this.$nextTick(async () => {
          await this.$refs.picker.validate()
        })
      } catch (err) {
        console.error(err)
      }
    },
    allowedMonths (val) {
      let lista = this.months
      return this.months.length > 0 ? (lista).includes(val) : true
    },
    dateSelected () {
      let dataArray = this.date.split('-')
      let dataSelecionada = `${dataArray[1]}/${dataArray[0]}`
      this.valueData = false
      this.$emit('selected', dataSelecionada)
    },
    async reset () {
      try {
        await this.$refs.picker.reset()
      } catch (err) {
        console.error(err)
      }
    },
    orgarnizarData (value) {
      value = value.split('-')
      if (value.length === 2 && this.typeCalendar === 'month') {
        this.dado = `${value[1]}/${value[0]}`
      } else if (value.length === 3 && this.typeCalendar === 'date') {
        this.dado = `${value[2]}/${value[1]}/${value[0]}`
      }
      this.validate()
      this.$emit('value', this.dado)
      this.$emit('dateValor', this.dado)
    },
    organizarDataDado (value) {
      if (value) {
        this.dado = value
        if (this.dado.length === 10 && this.typeCalendar === 'date') {
          let split = this.dado.split('/')
          this.dateValor = `${split[2]}-${split[1]}-${split[0]}`
          this.$emit('dateValor', this.dateValor)
        } else if (this.dado.length === 7 && this.typeCalendar === 'month') {
          let split = this.dado.split('/')
          this.dateValor = `${split[1]}-${split[0]}`
          this.$emit('dateValor', this.dateValor)
        } else {
          this.dateValor = ''
          this.$emit('dateValor', this.dateValor)
        }
        this.$emit('value', this.dado)
      } else {
        this.$emit('value', '')
      }
    },

    showDatepicker () {
      if (!this.disabled) {
        this.valueData = !this.valueData
      }
    },

    formatarData (value) {
      if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(value)) { return false }

      var parts = value.split('/')
      var day = parseInt(parts[0], 10)
      var month = parseInt(parts[1], 10)
      var year = parseInt(parts[2], 10)

      month = month > 9 ? month : '0' + month

      var formatado = `${year}-${month}-${day}`

      return formatado
    }
  },
  watch: {
    value () {
      this.valueData = this.value
    },
    valueData () {
      this.$emit('input', this.valueData)
    },
    propMonths () {
      this.months = this.propMonths
    },
    inputValue () {
      this.dado = this.inputValue
      if (this.dado === '') {
        this.dateValor = ''
        this.reset()
        this.$emit('dateValor', this.dateValor)
      }
    },
    minDate () {
      let split = this.minDate.split('/')
      this.minDateData = `${split[2]}-${split[1]}-${split[0]}`
    },
    maxDate () {
      let split = this.maxDate.split('/')
      this.maxDateData = `${split[2]}-${split[1]}-${split[0]}`
    },
    validateProviderRules () {
      this.validateProviderRulesData = this.validateProviderRules
    }
  }
}
</script>

<style>
.v-date-picker-table table {
    min-width: 100px !important;
}

.v-date-picker-years .active {
    background: white !important
}
.datePicker{
  height:360px;
}
.v-date-picker-table  table td{
    padding: 0px;
}

</style>
